import { render, staticRenderFns } from "./GooglePay.vue?vue&type=template&id=732c2ec8&scoped=true"
import script from "./GooglePay.vue?vue&type=script&lang=js"
export * from "./GooglePay.vue?vue&type=script&lang=js"
import style0 from "./GooglePay.vue?vue&type=style&index=0&id=732c2ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c2ec8",
  null
  
)

export default component.exports